import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'

export const GET_WORKFLOWS = gql`
query GET_WORKFLOWS {
  mdm_workflow(order_by: {organization: {name: asc}}) {
    id
    description
    organization {
      id
      name
    }
  }
}
`

export const GET_WORKFLOW_STEPS = gql`
query GET_WORKFLOW_STEPS($_eq: Int!) {
  mdm_workflow_step(where: {workflowId: {_eq: $_eq}}, order_by: {stepOrder: asc}) {
    id
    name
  }
}
`
// ############################### ORGANIZATION DIVISION ###############################
export const INSERT_ORGANIZATION_DIVISION = gql`
mutation INSERT_ORGANIZATION_DIVISION($objects: [mdm_organization_division_insert_input!]!) {
  insert_mdm_organization_division(objects: $objects) {
    returning {
      id
    }
  }
}
`

export const GET_ORGANIZATION_DIVISIONS = gql`
query GET_ORGANIZATION_DIVISIONS($orgId: uuid) {
  mdm_organization_division(where: {organizationId: {_eq: $orgId}}, order_by: {id: desc}) {
    centerCode
    name
    id
    createdAt
    parentCode
    parentCodeId
    parentName
    updatedAt
  }
}
`

export const GET_PARENT_ORGANIZATION_DIVISION = gql`
query GET_PARENT_ORGANIZATION_DIVISON($orgId: uuid!) {
  mdm_organization_division(where: {organizationId: {_eq: $orgId}, parentCodeId: {_is_null: true}}, order_by: {centerCode: asc}) {
    centerCode
    name
    id
  }
}
`
// ############################### AMSA TYPES ###############################
// Same query is used to Update and Insert
const INSERT_WF_TYPE = (wfName) => {
  return gql`
    mutation INSERT_WF_TYPE($update_columns: [mdm_${wfName}_types_update_column!] = [code, name, parent_code, short_name, combo_objeto, is_active, description], $objects: [mdm_${wfName}_types_insert_input!]!) {
      insert_mdm_${wfName}_types(objects: $objects, on_conflict: {constraint: ${wfName}_types_pkey, update_columns: $update_columns}) {
        returning {
          id
        }
      }
    }
  `
}

const GET_WF_TYPES = (wfName) => {
  return gql`
  query GET_WF_TYPES($searchValue: String = null,, $limit: Int = 15, $offset: Int = 0) {
    mdm_${wfName}_types(where: { _or: [
        { code: { _ilike: $searchValue } },
        { combo_objeto: { _ilike: $searchValue } },
        { name: { _ilike: $searchValue } },
        { description: { _ilike: $searchValue } }
      ] }, order_by: {id: desc}, limit: $limit, offset: $offset) {
      code
      combo_objeto
      id
      name
      parent_code
      short_name
      is_active
      description
    }
    mdm_${wfName}_types_aggregate(where: {  _or: [
        { code: { _ilike: $searchValue } },
        { combo_objeto: { _ilike: $searchValue } },
        { name: { _ilike: $searchValue } },
        { description: { _ilike: $searchValue } }
      ]}, order_by: {id: desc}) {
      aggregate {
        count
      }
    }
  }
  `
}
// ############################### IDM AMSA ###############################
// Same query is used to Update and Insert
export const INSERT_IDM_AMSA = gql`
mutation INSERT_IDM_AMSA($objects: [mdm_idm_amsa_insert_input!]!, $update_columns: [mdm_idm_amsa_update_column!] = [code,name,user_id]) {
  insert_mdm_idm_amsa(objects: $objects, on_conflict: {constraint: idm_amsa_pkey, update_columns: $update_columns}) {
    returning {
      id
    }
  }
}
`

export const GET_IDM_AMSA = gql`
query GET_IDM_AMSA($offset: Int = 0, $limit: Int = 10) {
  mdm_idm_amsa(order_by: {id: desc}, offset: $offset, limit: $limit) {
    id
    code
    name
    user_id
    user {
      id
      email
    }
  }
  mdm_idm_amsa_aggregate {
    aggregate {
      count
    }
  }
}
`

export const GET_USER_REMOTE_SEARCH = gql`
query GET_USER_REMOTE_SEARCH($email: String, $id: uuid) {
  user(limit: 20, where: {_or: {email: {_ilike: $email}, id: {_eq: $id}}}) {
    email
    id
    first_name
    last_name
  }
}
`

export const DELETE_IDM_AMSA = gql`
mutation DELETE_IDM_AMSA($id: Int!) {
  delete_mdm_idm_amsa_by_pk(id: $id) {
    id
  }
}
`
// ############################### Permisos por etapa (workflow_user) ###############################
// Same query is used to Update and Insert
export const INSERT_WORKFLOW_USER = gql`
mutation INSERT_WORKFLOW_USER($objects: [mdm_workflow_user_insert_input!]!, $update_columns: [mdm_workflow_user_update_column!] = [canApprove,canCancel,canReject,canSave,id,workflowStepId,organizationDivisionId,userId,updatedAt]) {
  insert_mdm_workflow_user(objects: $objects, on_conflict: {constraint: PK_aeb7d3f88218c3ec8470bec9863, update_columns: $update_columns}) {
    returning {
      id
    }
  }
}
`

export const GET_WORKFLOW_USERS = gql`
query GET_WORKFLOW_USERS($workflowId: Int!, $limit: Int = 15, $offset: Int = 0) {
  mdm_workflow_user(order_by:  [{user:{id: desc}}, {workflowStepId: asc}, {organizationDivisionId: desc}], where: {workflowId: {_eq: $workflowId}}, limit: $limit, offset: $offset) {
    canApprove
    canCancel
    canReject
    canSave
    id
    organization_division {
      id
      name
      centerCode
      __typename
    }
    workflow_step {
      name
      stepId: id
      __typename
    }
    user {
      id
      email
      first_name
      last_name
      __typename
    }
    __typename
  }
  mdm_workflow_user_aggregate(where: {workflowId: {_eq: $workflowId}}) {
    aggregate {
      count
      __typename
    }
    __typename
  }
}
`


export const GET_WORKFLOW_USERS_BY_USER_ID = gql`
query GET_WORKFLOW_USERS_BY_USER_ID($workflowId: Int!, $userId: uuid) {
  mdm_workflow_user(
    order_by:  [{workflowStepId: asc},{organizationDivisionId: desc}],
    where: {
      workflowId: { _eq: $workflowId }
      user: { id: { _eq: $userId } }
    },
  ) {
    canApprove
    canCancel
    canReject
    canSave
    id
    organization_division {
      id
      name
      centerCode
      __typename
    }
    workflow_step {
      name
      stepId: id
      __typename
    }
    user {
      id
      email
      first_name
      last_name
      __typename
    }
    __typename
  }
  mdm_workflow_user_aggregate(where: { workflowId: { _eq: $workflowId } }) {
    aggregate {
      count
      __typename
    }
    __typename
  }
}
`

export const GET_WF_STEPS_DROPDOWN = gql`
query GET_WF_STEPS_DROPDOWN($workflowId: Int!) {
  mdm_workflow_step(order_by: {stepOrder: asc}, where: {workflowId: {_eq: $workflowId}}) {
    stepId: id
    name
  }
}
`
export const GET_CENTERS_DROPDOWN = gql`
query GET_CENTERS_DROPDOWN($organizationId: uuid!) {
  mdm_organization_division(where: {organizationId: {_eq: $organizationId}, parentCodeId: {_is_null: false}}, order_by: {name: asc}) {
    centerCode
    id
    name
    parentName
  }
}
`

export const DELETE_WF_USER = gql`
mutation DELETE_WF_USER($id: Int!) {
  delete_mdm_workflow_user_by_pk(id: $id) {
    id
  }
}

`

const workflows = {
  namespaced: true,
  state: {
    orgDivList: [],
    parentOrgDivList: [],
    workflowSelected: null,
    workflowSteps: [],
    amsaTypeTable: {},
    wfTypeTable: {},
    idmAmsaTable: {},
    usrRemoteSearchDropdown: [],
    wfUserTable: {},
    wfStepsDropdown: [],
    centersDropdown: [],
    wfUserByUserId: {}
  },
  actions: {
    async getOrgDivList ({ state }) {
      try {
        const result = await apolloClient.query({ query: GET_ORGANIZATION_DIVISIONS, variables: { orgId: state.workflowSelected.organization.id }, fetchPolicy: 'network-only' })
        if (!result || !result.data) return
        Vue.set(state, 'orgDivList', result.data.mdm_organization_division)
        return result.data.mdm_organization_division
      } catch (err) {
        window.console.error(err)
      }
    },
    async getParentOrgDivList ({ state }) {
      try {
        const result = await apolloClient.query({ query: GET_PARENT_ORGANIZATION_DIVISION, variables: { orgId: state.workflowSelected.organization.id }, fetchPolicy: 'network-only' })
        if (!result || !result.data) return
        Vue.set(state, 'parentOrgDivList', result.data.mdm_organization_division)
        return result.data.mdm_organization_division
      } catch (err) {
        window.console.error(err)
      }
    },
    async getWorkflows (store) {
      try {
        const result = await apolloClient.query({ query: GET_WORKFLOWS })
        if (!result || !result.data) return
        return result.data.mdm_workflow
      } catch (err) {
        window.console.error(err)
      }
    },
    async getWorkflowSteps ({ state }, variables) {
      try {
        const result = await apolloClient.query({ query: GET_WORKFLOW_STEPS, variables })
        if (!result || !result.data) return
        Vue.set(state, 'workflowSteps', result.data.mdm_workflow_step)
        return result.data.mdm_workflow_step
      } catch (err) {
        window.console.error(err)
      }
    },
    async insertOrganizationDivision (store, objects) {
      try {
        const insertMutation = {
          mutation: INSERT_ORGANIZATION_DIVISION,
          variables: { objects }
        }
        const result = await apolloClient.mutate(insertMutation)
        if (!result || result.error) throw new Error(result)
        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    },
    async getWfTypes ({ state }, allVars) {
      try {
        const variables = { ...allVars }
        delete variables.wfName
        const result = await apolloClient.query({ query: GET_WF_TYPES(allVars.wfName), variables, fetchPolicy: 'network-only' })
        if (!result || !result.data) return
        Vue.set(state.wfTypeTable, 'data', result.data[`mdm_${allVars.wfName}_types`])
        Vue.set(state.wfTypeTable, 'totalRows', result.data[`mdm_${allVars.wfName}_types_aggregate`].aggregate.count)
      } catch (err) {
        window.console.error(err)
      }
    },
    async insertWfType (store, objects) {
      try {
        const objTmp = JSON.parse(JSON.stringify(objects))
        delete objTmp[0].wfName
        const insertMutation = {
          mutation: INSERT_WF_TYPE(objects[0].wfName),
          variables: { objects: objTmp }
        }
        const result = await apolloClient.mutate(insertMutation)
        if (!result || result.error) throw new Error(result)
        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    },
    async remoteSearch ({ state }, allVars) {
      try {
        const variables = { ...allVars }
        delete variables.wfName
        const result = await apolloClient.query({ query: GET_WF_TYPES(allVars.wfName), variables })
        if (!result || !result.data) return
        Vue.set(state, 'remoteSearchData', result.data[`mdm_${allVars.wfName}_types`])
      } catch (err) {
        window.console.error(err)
      }
    },
    async insertIdmAmsa (store, objects) {
      try {
        const result = await apolloClient.mutate({ mutation: INSERT_IDM_AMSA, variables: { objects } })
        if (!result || result.error) throw new Error(result)
        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    },
    async getIdmAmsa ({ state }, variables) {
      try {
        const result = await apolloClient.query({ query: GET_IDM_AMSA, variables, fetchPolicy: 'network-only' })
        if (!result || !result.data) return
        Vue.set(state.idmAmsaTable, 'data', result.data.mdm_idm_amsa)
        Vue.set(state.idmAmsaTable, 'totalRows', result.data.mdm_idm_amsa_aggregate.aggregate.count)
        return result.data.mdm_amsa_types
      } catch (err) {
        window.console.error(err)
      }
    },
    async remoteSearchUser (store, variables) {
      try {
        const result = await apolloClient.query({ query: GET_USER_REMOTE_SEARCH, variables })
        if (!result || !result.data) return []
        return result.data.user
      } catch (err) {
        window.console.error(err)
        return []
      }
    },
    async wfStepDropdown ({ state }) {
      try {
        const result = await apolloClient.query({ query: GET_WF_STEPS_DROPDOWN, variables: { workflowId: state.workflowSelected.id } })
        if (!result || !result.data) return
        Vue.set(state, 'wfStepsDropdown', result.data.mdm_workflow_step)
      } catch (err) {
        window.console.error(err)
      }
    },
    async getCentersDropdown ({ state }) {
      try {
        const result = await apolloClient.query({ query: GET_CENTERS_DROPDOWN, variables: { organizationId: state.workflowSelected.organization.id }, fetchPolicy: 'network-only' })
        if (!result || !result.data) return
        Vue.set(state, 'centersDropdown', result.data.mdm_organization_division)
      } catch (err) {
        window.console.error(err)
      }
    },
    async deleteIdmAmsa (store, variables) {
      try {
        const result = await apolloClient.mutate({ mutation: DELETE_IDM_AMSA, variables })
        if (!result || result.error) throw new Error(result)
        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    },
    async insertWorkflowUser (store, objects) {
      try {
        const result = await apolloClient.mutate({ mutation: INSERT_WORKFLOW_USER, variables: { objects } })
        if (!result || result.error) throw new Error(result)
        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    },
    async getWorkflowUsers ({ state }, variables) {
      try {
        const result = await apolloClient.query({ query: GET_WORKFLOW_USERS, variables: { workflowId: state.workflowSelected.id, ...variables }, fetchPolicy: 'network-only' })
        if (!result || !result.data) return
        Vue.set(state.wfUserTable, 'data', result.data.mdm_workflow_user)
        Vue.set(state.wfUserTable, 'totalRows', result.data.mdm_workflow_user_aggregate.aggregate.count)
      } catch (err) {
        window.console.error(err)
      }
    },
    async getWorkflowUsersByUserId ({ state }, variables) {
      try {
        const result = await apolloClient.query({ query: GET_WORKFLOW_USERS_BY_USER_ID, variables: { workflowId: state.workflowSelected.id, ...variables }, fetchPolicy: 'network-only' })
        if (!result || !result.data) return
        Vue.set(state.wfUserByUserId, 'data', result.data.mdm_workflow_user)
        return state.wfUserByUserId
      } catch (err) {
        window.console.error(err)
      }
    },
    async deleteWfUser (store, variables) {
      try {
        const result = await apolloClient.mutate({ mutation: DELETE_WF_USER, variables })
        if (!result || result.error) throw new Error(result)
        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    }
  },
  mutations: {
    SET_WORKFLOWS (state, data) {
      Vue.set(state, 'workflowSelected', data)
    }
  }
}

export default workflows



// WEBPACK FOOTER //
// ./src/store/modules/workflows.js